import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {TenInfoDesk} from "../../_models/info-desk.models";

export const loadList = createAction(
    '[Info Desk] Load List',
    props<{ uuid: string }>()
);

export const loadListSuccess = createAction(
    '[Info Desk] Load List Success',
    props<{ items: TenInfoDesk[] }>()
);

export const loadListFailure = createAction(
    '[Info Desk] Load List Failure',
    props<{ error: HttpErrorResponse }>()
);

export const deletedFromWS = createAction(
    '[Info Desk] Deleted From WS',
    props<{ itemId: string }>()
);

export const editedFromWS = createAction(
    '[Info Desk] Edited From WS',
    props<{ item: TenInfoDesk }>()
);
